module.exports = __webpack_public_path__ + "img/experiences_icon.2ae00465.svg";